/**
 * Stato di collegamento del numero WhatsApp attivo, letto da
 * api_configurations.session_health_status (scritto dal controllo periodico
 * delle sessioni e, a breve, subito dal core quando il numero si scollega).
 */

const DISCONNECTED = new Set(['error', 'failed', 'disconnected', 'logged_out', 'not_found']);

export function isNumberDisconnected(status: string | null | undefined): boolean {
  if (!status) return false;
  return DISCONNECTED.has(status.toString().trim().toLowerCase());
}

/** Nome con cui mostrare il numero nel banner. */
export function numberLabel(cfg: { display_name?: string | null; configuration?: Record<string, unknown> | null } | null | undefined): string {
  if (!cfg) return 'attivo';
  const conf = (cfg.configuration || {}) as Record<string, unknown>;
  const raw = (conf.phone_number || conf.display_phone_number || '') as string;
  const phone = typeof raw === 'string' ? raw.replace(/@.*$/, '').trim() : '';
  const phoneLabel = phone ? (phone.startsWith('+') ? phone : `+${phone}`) : '';
  if (cfg.display_name && phoneLabel) return `${cfg.display_name} (${phoneLabel})`;
  return cfg.display_name || phoneLabel || 'attivo';
}
